export interface DocumentFileNameOptions {
  documentType: string;
  serviceName?: string;
  reference?: string;
  date?: string | Date;
}

const normalisePart = (value: string) =>
  value
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/\.pdf$/i, "")
    .replace(/[<>:"/\\|?*]/g, " ")
    .split("")
    .filter((character) => character.charCodeAt(0) >= 32)
    .join("")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

const formatDate = (value: string | Date) => {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? normalisePart(String(value)) : date.toISOString().slice(0, 10);
};

export const ensurePdfExtension = (fileName: string) => {
  const safeName = normalisePart(fileName) || "document";
  return `${safeName}.pdf`;
};

export const buildDocumentFileName = ({
  documentType,
  serviceName,
  reference,
  date,
}: DocumentFileNameOptions) => {
  const parts = [serviceName, documentType, reference, date ? formatDate(date) : undefined]
    .filter((part): part is string => Boolean(part))
    .map(normalisePart)
    .filter(Boolean);

  return ensurePdfExtension(parts.join("-"));
};
